import apiClient from '../apiClient';
import { PUT_EXCURSION_URL } from '../apiUrl';

const putExcurtionApi = (id, data) => {
  return apiClient.put(PUT_EXCURSION_URL(id), data);
};

export default putExcurtionApi;
